/**
 * Soft-quote inputs — the four fields the user enters on the landing
 * page that drive the initial ILF/DLF lookup. In-memory only; a tab
 * reload resets them back to defaults.
 */
class QuoteFormStore {
  #listeners = new Set();

  #zip = "";
  #effDate = "";
  #paClass = "PA1";
  #employment = "w2";

  get zip() { return this.#zip; }
  set zip(v) { this.#zip = v; this.#notify(); }

  get effDate() { return this.#effDate; }
  set effDate(v) { this.#effDate = v; this.#notify(); }

  get paClass() { return this.#paClass; }
  set paClass(v) { this.#paClass = v; this.#notify(); }

  get employment() { return this.#employment; }
  set employment(v) { this.#employment = v; this.#notify(); }

  subscribe(listener) {
    this.#listeners.add(listener);
    return () => this.#listeners.delete(listener);
  }

  #notify() { this.#listeners.forEach((l) => l()); }

  clear() {
    this.#zip = "";
    this.#effDate = "";
    this.#paClass = "PA1";
    this.#employment = "w2";
    this.#notify();
  }
}

const quoteFormStore = new QuoteFormStore();
export default quoteFormStore;
